import { render, staticRenderFns } from "./gross-assets-bar.vue?vue&type=template&id=5028ea88&scoped=true"
import script from "./gross-assets-bar.vue?vue&type=script&lang=js"
export * from "./gross-assets-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028ea88",
  null
  
)

export default component.exports